import { graphql } from "gql";

const ADD_USERS_TO_CALL_MUTATION = graphql(`
  mutation AddUsersToVideoCall($input: AddUsersToCallInput!) {
    addUsersToCall(input: $input) {
      ...Call
    }
  }
`);

export default ADD_USERS_TO_CALL_MUTATION;
